import React from 'react';
import SectionHeader from '../SectionHeader';
import SectionChapter from '../SectionChapter';

const GuestAccess = ({ language, refs }) => {
    const guestLoginSet = [
        {
            id: 'tutorial.guestAccess.login.explanation1',
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/guest_signIn.jpeg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/guest_name.jpeg`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/guest_lessonLink.jpeg`,
            ],
        },
        {
            id: 'tutorial.guestAccess.login.explanation2',
        },
    ];

    const guestReturnSet = [
        {
            id: 'tutorial.guestAccess.return.explanation1',
        },
        {
            id: 'tutorial.guestAccess.return.explanation2',
        },
        {
            id: 'tutorial.guestAccess.return.explanation3',
        },
    ];

    const guestLimitsSet = [
        {
            id: 'tutorial.guestAccess.limits.explanation1',
        },
        {
            id: 'tutorial.guestAccess.limits.explanation2',
        },
    ];

    return (
        <>
            <SectionHeader
                refs={refs}
                title={'tutorial.guestAccess.title'}
                description={'tutorial.guestAccess.description'}
                id={'section-guestAccess'}
            />
            <SectionChapter
                refs={refs}
                id={'section-guestAccess-login'}
                title={'tutorial.guestAccess.login'}
                explanations={guestLoginSet}
                imageTop={false}
            />
            <SectionChapter
                refs={refs}
                id={'section-guestAccess-return'}
                title={'tutorial.guestAccess.return'}
                explanations={guestReturnSet}
                imageTop={false}
            />
            <SectionChapter
                refs={refs}
                id={'section-guestAccess-limits'}
                title={'tutorial.guestAccess.limits'}
                explanations={guestLimitsSet}
                imageTop={false}
            />
        </>
    );
};

export default GuestAccess;
